import useCountryHistory from "../../../hooks/users/useCountryHistory";

interface Props {
  userId: string;
}

export default function CountryHistory({ userId }: Props) {
  const { countryHistory, loading, error } = useCountryHistory({ userId });

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Erreur chargement</div>;

  if (!countryHistory || countryHistory.length === 0) {
    return <div>Aucun historique</div>;
  }

  return (
    <div className="space-y-3">
      {countryHistory?.map((item: any) => (
        <div key={item.id} className="border rounded-lg p-3 flex flex-col gap-1">
          <div className="text-sm">
            <b>{item.old_country.name}</b> ➜ <b>{item.new_country.name}</b>
          </div>

          <div className="text-xs text-gray-500">
            Modifié par {item.changed_by_user.first_name} {item.changed_by_user.last_name}
          </div>

          <div className="text-xs text-gray-400">{new Date(item.changed_at).toLocaleString()}</div>
        </div>
      ))}
    </div>
  );
}
